import request from "../request";

export const getListWithFilter = ({
  region,
  province,
  city,
  salesId,
  pageIndex,
  pageSize,
}) => {
  const url = `/store?region=${region}&province=${province}&city=${city}&salesId=${salesId}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
  return request.get(url);
};

export const getStoreList = (url) => {
  return request.get(url);
};

export const getStoreWithId = ({ id }) => {
  const url = `/store/${id}`;
  return request.get(url);
};

export const addStore = (payload) => {
  const url = "/store/add";
  return request.post(url, payload);
};

export const deleteStore = ({ id }) => {
  const url = `/store/${id}`;
  return request.delete(url);
};

export const getStorebyRegion = (payload) => {
  const url = "/store/store_count_group_by_region";
  return request.post(url, payload);
};

export const getStorebyCity = (payload) => {
  const url = "/store/store_count_group_by_city";
  return request.post(url, payload);
};

export const exportStore = (payload) => {
  const url = `/store/export?name=${payload.name}&region=${payload.region}&province=${payload.province}&city=${payload.city}&salesId=${payload.salesId}&year=${payload.year}`;
  return request.get(url, {
    responseType: "blob",
  });
};

export const importStore = (data) => {
  const url = "/store/upload";
  return request.post(url, data, {
    responseType: "blob",
  });
};
